
import { getCompanySet, modifyCompanySet } from '@/api/system';
import { UserModule } from '@/store/modules/user';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  name: 'ClockInSetting',
  components: {

  }
})
export default class extends Vue {
  private formPath: any = {
    engineer: '',
    startTime: '',
    endTime: '',
    engineerTask: ''
  }
  created() {
    this.getCompanySet();
  }
  private getCompanySet() {
    let params:any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    params.vip_level = (UserModule.company as any).vip_level;
    getCompanySet(params).then(res => {
      if (res.data && res.data.companySet) {
        let starthour:any = parseInt(res.data.companySet.trajectory_record_start_time) / 3600;
        if (parseInt(starthour) < 10) {
          starthour = '0' + parseInt(starthour);
        } else {
          starthour = parseInt(starthour);
        }
        let startmin:any = (parseInt(res.data.companySet.trajectory_record_start_time) - 3600 * parseInt(starthour)) / 60;
        if (parseInt(startmin) < 10) {
          startmin = '0' + parseInt(startmin);
        } else {
          startmin = parseInt(startmin);
        }

        let endhour:any = parseInt(res.data.companySet.trajectory_record_end_time) / 3600;
        if (parseInt(endhour) < 10) {
          endhour = '0' + parseInt(endhour);
        } else {
          endhour = parseInt(endhour);
        }
        let endtmin:any = (parseInt(res.data.companySet.trajectory_record_end_time) - 3600 * parseInt(endhour)) / 60;
        if (parseInt(startmin) < 10) {
          endtmin = '0' + parseInt(endtmin);
        } else {
          endtmin = parseInt(endtmin);
        }
        this.formPath.engineer = parseInt(res.data.companySet.is_trajectory_record) === 1;
        this.formPath.engineerTask = parseInt(res.data.companySet.is_task_track_record) === 1;
        this.formPath.startTime = starthour + ':' + startmin;
        this.formPath.endTime = endhour + ':' + endtmin;
      }
    }).catch(err => {
      let msg = err.msg;
    });
  }
  private backgroundChange(val:any) {
    // let params:any = {};
    // params.is_trajectory_record = this.formPath.engineer ? '1' : '0';
    // params.is_task_track_record = this.formPath.engineerTask ? '1' : '0';
    // this.modifyCompanySet(params);
  }
  private save() {
    let timesStart = this.formPath.startTime.split(':');
    let timesEnd = this.formPath.endTime.split(':');
    let params:any = {};
    params.trajectory_record_start_time = timesStart[0] * 3600 + timesStart[1] * 60;
    params.trajectory_record_end_time = timesEnd[0] * 3600 + timesEnd[1] * 60;
    params.is_trajectory_record = this.formPath.engineer ? '1' : '0';
    params.is_task_track_record = this.formPath.engineerTask ? '1' : '0';
    this.modifyCompanySet(params);
  }
  private modifyCompanySet(pamars:any) {
    let params:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      ...pamars
    };
    modifyCompanySet(params).then(res => {
      this.showSuccessMsg((res as any).msg);
      this.getCompanySet();
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
